/* ════════════════════════════════════════════════════════════════
   PLANTWIJZER — Kwekerij Imenhof · logica  (fixrelease 2026-07-14)
   Eén universele calculator: rechte lijn (haag/rij) · rechthoek
   (border/bak) · rond. Maten in meters of centimeters.

   Wijzigingen in deze fixrelease:
   · Variantbewust: de gekozen verkoopvariant bepaalt zichtbaarheid
     en advies. Vorm-/boomvarianten (stamhoogte, solitair, leivorm,
     dakvorm, piramide, geveerd, XXL, hangpot, rek, …) tonen géén
     calculator; een expliciet kwekersadvies "N per m²" in de
     varianttitel krijgt voorrang op de pootafstand.
   · Bomen en vormproducten (categorie Sierbomen / Vormbomen &
     meerstammen / Halfstammen zonder haagbare nevencategorie, of een
     vorm-metafield stam/piramide/rek, of een afgewerkt product zoals
     hangpot/op stam) tonen de calculator helemaal niet.
   · Eerlijke rekenregel vollegrond: geplant in driehoeksverband op de
     opgegeven afstand — aantal = oppervlakte × 2/(√3·afstand²) —
     zonder extra randrijen en zonder verborgen verdichting. In pot of
     bak geldt: tegen de rand planten (kwekersvuistregel), maar nooit
     dichter dan de plantafstand.
   · Invoerfouten zijn zichtbaar en aan het veld gekoppeld
     (aria-describedby + rol alert); er wordt níet stil geklemd en
     zolang de invoer ongeldig is wordt géén nieuw advies berekend.
   · De beginwaarde in de HTML is een laadstatus (—), geen verzonnen
     getal meer; de telanimatie respecteert prefers-reduced-motion.
   · De mobiele sticky staat boven de koopbalk (meet de hoogte van
     .product-mobile-buybar) en ruimt zichzelf op bij
     shopify:section:unload — geen duplicaten in de thema-editor.
   · Standaardvorm per product: rij alleen voor haagbare planten;
     "extra dichte haag" verschijnt alleen dáár.
   ════════════════════════════════════════════════════════════════ */
(function(){
'use strict';
var root = document.getElementById('plantwijzer');
if (!root) return;

/* eerdere sticky-restanten (thema-editor herlaadt secties) opruimen */
document.querySelectorAll('body > .pw-plak').forEach(function(n){ n.remove(); });

const REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* Invoerbereiken per eenheid (validatie + de −/+ knoppen). */
const CONF = {
  lijnLen: { m:{min:0.1, max:200, step:0.5, std:6},   cm:{min:10, max:20000, step:10, std:100} },
  rechtL:  { m:{min:0.1, max:50,  step:0.5, std:3},   cm:{min:10, max:5000,  step:5,  std:60}  },
  rechtB:  { m:{min:0.1, max:50,  step:0.5, std:1.5}, cm:{min:10, max:5000,  step:5,  std:20}  },
  diam:    { m:{min:0.1, max:30,  step:0.5, std:2.5}, cm:{min:10, max:3000,  step:5,  std:40}  },
  afstand: { cm:{min:10, max:2000, step:5,  std:25} },
};
const INVOEREN = [ ['sLijn','lijnLen'], ['sRechtL','rechtL'], ['sRechtB','rechtB'], ['sDiam','diam'] ];

const s = { mode:'lijn', eenheid:'m', dubbel:false, afstand:25, bladMaat:25, dichtheid:null,
            plek:'vollegrond', plekHandmatig:false,
            lijnLen:6, rechtL:3, rechtB:1.5, diam:2.5 };
let productPlant = false;
let aanbevolenAfstand = null;      /* actieve aanbeveling (pootafstand of uit m²-advies) */
let ongeldigeVelden = new Set();   /* veld-ids met foute invoer → niet rekenen */

const KLUIT = blad => klem(0.2*blad, 3, 8);

const nf  = new Intl.NumberFormat('nl-NL');
const nf1 = new Intl.NumberFormat('nl-NL',{maximumFractionDigits:1});
const nf2 = new Intl.NumberFormat('nl-NL',{maximumFractionDigits:2});
const el  = id => document.getElementById('pw-'+id);
const alle = sel => [...root.querySelectorAll(sel)];
const klem = (v,a,b)=>Math.max(a,Math.min(b,v));
const fmtMaat = v => s.eenheid==='m' ? `${nf2.format(v)} m` : `${Math.round(v)} cm`;
const fmtGetal = (v,eenh) => eenh==='m' ? nf2.format(v) : String(Math.round(v));
const fmtAfstand = cm => cm < 100
  ? `${Number.isInteger(cm) ? cm : nf1.format(cm)} cm`
  : `${nf2.format(cm/100)} m`;
const inMeter = v => s.eenheid==='m' ? v : v/100;
const parseGetal = t => {
  const v = parseFloat(String(t).trim().replace(',','.'));
  return Number.isFinite(v) ? v : null;
};

/* ── Productgegevens uit de sectie ── */
function leesJson(sel){
  const n = root.querySelector(sel);
  if (!n) return null;
  try { return JSON.parse(n.textContent); } catch(e){ return null; }
}
const P = leesJson('[data-pw-product]') || {};
const CATS = (P.categorie || []).map(String);
const TAGS = (P.tags || []).map(String);
const VORM_MF = (P.vormMf || []).map(x => String(x).toLowerCase());
const VARIANTEN = P.varianten || [];

function leesPootafstand(){
  const ruw = String(root.dataset.pootafstandCm || '').trim().replace(',', '.');
  if (!/^\d+(?:\.\d+)?$/.test(ruw)) return null;
  const cm = parseFloat(ruw);
  if (!Number.isFinite(cm) || cm <= 0) return null;
  return klem(cm, 5, 2000);
}

/* ── Variant- en productbeoordeling ──
   Vormvarianten en boomproducten: geen aantal-advies (besluit
   eigenaar 2026-07-14). Kwekersadvies "N per m²" in de varianttitel
   wint van de afgeleide pootafstand. */
const VORM_RE = /stamhoogte|stamomtrek|\bstam\b|halfstam|hoogstam|op stam|solitair|leivorm|dakvorm|\bscherm\b|piramide|pyramide|geveerd|meerstammig|kroon\s*Ø|bol\s*Ø|spiraal|pompon|bonsai|XXL|hangpot|\brek\b|espalier/i;
const M2_RE = /(\d+(?:[.,]\d+)?)\s*(?:planten|plant|st(?:uks)?\.?)?\s*(?:per|\/)\s*m\s*(?:²|2)/i;
const BOOM_CATS = ['Sierbomen','Vormbomen & meerstammen','Halfstammen'];
const HAAG_CATS = ['Heesters','Haagplanten','Bos- & haagplantsoen','Groenblijvende bodembedekkers',
                   'Siergrassen','Rhododendron & azalea','Vaste planten','Klimplanten'];
const AFGEWERKT_RE = /op stam|hangpot|piramide|pyramide|\brek\b|XXL|flowerbag/i;

function productAltijdVerbergen(){
  if (VORM_MF.some(v => v==='stam' || v==='piramide' || v==='rek')) return true;
  if (AFGEWERKT_RE.test(String(P.titel||''))) return true;
  const isBoom = CATS.some(c => BOOM_CATS.indexOf(c) > -1);
  const isHaagbaar = CATS.some(c => HAAG_CATS.indexOf(c) > -1);
  if (isBoom && !isHaagbaar) return true;
  if (VARIANTEN.length && VARIANTEN.every(v => VORM_RE.test(v.t))) return true;
  return false;
}
function beoordeelVariant(titel){
  const t = String(titel || '');
  if (t && t !== 'Default Title' && VORM_RE.test(t)) return { verberg:true, dichtheid:null };
  const m = t.match(M2_RE);
  if (m) return { verberg:false, dichtheid: parseFloat(m[1].replace(',','.')) };
  return { verberg:false, dichtheid:null };
}
const haagPlausibel = CATS.some(c => c==='Haagplanten' || c==='Bos- & haagplantsoen')
  || /haag/i.test(String(P.titel||''));

/* Huidige variant volgen via de variantkiezer van het thema */
let huidigeVariantTitel = P.eersteVariant || (VARIANTEN[0] && VARIANTEN[0].t) || '';
function pickerVariantTitel(){
  const picker = document.querySelector('[data-variant-picker]');
  if (!picker) return null;
  const groepen = picker.querySelectorAll('.variant-group');
  if (!groepen.length) return null;
  const delen = [];
  groepen.forEach(function(g){
    const sel = g.querySelector('[data-variant-compact-select]');
    if (sel && sel.value){ delen.push(sel.value); return; }
    const radio = g.querySelector('input[type="radio"]:checked');
    delen.push(radio ? radio.value : '');
  });
  const t = delen.filter(Boolean).join(' / ');
  return t || null;
}

/* ── Rekenhart ──
   Vollegrond: driehoeksverband op de opgegeven afstand —
   aantal = oppervlakte × 2/(√3·a²). Geen randrijen, geen compressie.
   Met kwekersadvies: aantal = oppervlakte × N per m².
   Pot/bak: tegen de rand planten (kwekersvuistregel), nooit dichter
   dan de plantafstand. */
function dichtheidPerM2(){
  if (s.dichtheid) return s.dichtheid;
  const am = s.afstand/100;
  return 2/(Math.sqrt(3)*am*am);
}
function bakAs(Lcm, a, blad){
  const m = KLUIT(blad);
  const n = Math.max(1, Math.floor((Lcm - 2*m)/a + 1e-9) + 1);
  const stap = n > 1 ? (Lcm - 2*m)/(n - 1) : 0;   /* gelijk verdeeld, ≥ a */
  return { n, stap, marge: n > 1 ? m : Lcm/2 };
}
function potPunten(R, a, blad){
  const m = KLUIT(blad);
  const r0 = R - m;
  if (r0 < 0.25*blad) return { pts: [[0,0]], bol: Math.min(blad, 2.2*R) };
  const pts = [];
  const k = Math.max(3, Math.ceil(2*Math.PI*R/a - 1e-6));
  for (let i=0;i<k;i++){
    const t = i*2*Math.PI/k;
    pts.push([r0*Math.cos(t), r0*Math.sin(t)]);
  }
  const kransA = 2*Math.PI*r0/k;
  let r = r0 - a, ring = 1, binnenste = r0;
  const minRing = 0.3*Math.max(a, blad);
  while (r > minRing){
    const kk = Math.max(3, Math.ceil(2*Math.PI*r/a - 1e-6));
    const rot = ring*Math.PI/5;
    for (let i=0;i<kk;i++){
      const t = rot + i*2*Math.PI/kk;
      pts.push([r*Math.cos(t), r*Math.sin(t)]);
    }
    binnenste = r; r -= a; ring++;
  }
  if (binnenste >= 0.85*blad) pts.push([0,0]);
  return { pts, bol: Math.min(blad, 1.25*kransA) };
}
function bereken(){
  const a = s.dichtheid ? 100/Math.sqrt(s.dichtheid) : s.afstand;
  const blad = s.bladMaat > 0 ? s.bladMaat : a;
  const bak = (s.mode !== 'lijn' && s.plek === 'bak');
  const perM = 100/a;
  let aantal, opp = null, cX = null, cY = null, vx = null, vy = null, rondPts = null, potBol = null;
  let verband = false;
  if (s.mode==='lijn'){
    aantal = Math.ceil(inMeter(s.lijnLen)*perM*(s.dubbel?2:1) - 1e-9);
  } else if (s.mode==='rechthoek'){
    opp = inMeter(s.rechtL)*inMeter(s.rechtB);
    if (bak){
      const Lcm = inMeter(s.rechtL)*100, Bcm = inMeter(s.rechtB)*100;
      vx = bakAs(Lcm, a, blad); vy = bakAs(Bcm, a, blad);
      cX = vx.n; cY = vy.n;
      aantal = cX*cY;
    } else {
      verband = true;
      aantal = Math.max(1, Math.round(opp*dichtheidPerM2()));
    }
  } else {
    opp = Math.PI*Math.pow(inMeter(s.diam)/2,2);
    if (bak){
      const Rcm = inMeter(s.diam)*50;
      const pp = potPunten(Rcm, a, blad);
      rondPts = pp.pts; potBol = pp.bol;
      aantal = rondPts.length;
    } else {
      verband = true;
      aantal = Math.max(1, Math.round(opp*dichtheidPerM2()));
    }
  }
  return { aantal:Math.max(1,aantal), effA:a, blad, bak, potBol, perM, opp, cX, cY, vx, vy, rondPts, verband };
}

/* ── Tel-animatie (respecteert verminderde beweging) ── */
let telRaf, getoond = 0;
function toonAantal(naar){
  cancelAnimationFrame(telRaf);
  if (REDUCED){ el('num').textContent = nf.format(naar); getoond = naar; return; }
  const van = getoond, t0 = performance.now(), duur = 380;
  const stap = t => {
    const k = Math.min(1,(t-t0)/duur), e = 1-Math.pow(1-k,3);
    el('num').textContent = nf.format(Math.round(van+(naar-van)*e));
    if (k<1) telRaf = requestAnimationFrame(stap);
  };
  telRaf = requestAnimationFrame(stap);
  getoond = naar;
  setTimeout(()=>{ el('num').textContent = nf.format(naar); }, duur+80);
}

/* ── Organische plantbolletjes (deterministisch) ── */
const PALET = ['#2F6B4F','#3B7A59','#4C8A66','#5E9973','#6FA07E'];
function rnd(i){ let x = Math.sin(i*127.1+311.7)*43758.5453; return x-Math.floor(x); }
function blad(x,y,r,i){
  const c1 = PALET[i%PALET.length], c2 = PALET[(i+2)%PALET.length], c3 = PALET[(i+3)%PALET.length];
  const rot = Math.floor(rnd(i)*360), d = REDUCED ? 0 : Math.min(i*7,420);
  return `<g transform="translate(${x.toFixed(1)} ${y.toFixed(1)}) rotate(${rot})"><g class="pl" style="--d:${d}ms">`+
    `<circle r="${r.toFixed(1)}" fill="${c1}" stroke="rgba(20,40,28,.12)" stroke-width="1"/>`+
    `<circle cx="${(-r*.42).toFixed(1)}" cy="${(r*.2).toFixed(1)}" r="${(r*.6).toFixed(1)}" fill="${c2}"/>`+
    `<circle cx="${(r*.38).toFixed(1)}" cy="${(r*.26).toFixed(1)}" r="${(r*.52).toFixed(1)}" fill="${c3}"/>`+
    `<circle cx="${(-r*.08).toFixed(1)}" cy="${(-r*.3).toFixed(1)}" r="${(r*.3).toFixed(1)}" fill="#8FBE9B" opacity=".85"/>`+
    `</g></g>`;
}

function maatlijn(x1,y1,x2,y2,label,vert){
  const mx=(x1+x2)/2, my=(y1+y2)/2, K='#7C8A7B';
  const tick = vert ? `M${x1-5} ${y1}H${x1+5} M${x2-5} ${y2}H${x2+5}` : `M${x1} ${y1-5}V${y1+5} M${x2} ${y2-5}V${y2+5}`;
  const w = label.length*6.6+16;
  return `<g font-family="'Hanken Grotesk',system-ui" font-size="11.5" font-weight="600">`+
    `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="${K}" stroke-width="1.1"/><path d="${tick}" stroke="${K}" stroke-width="1.1"/>`+
    `<rect x="${mx-w/2}" y="${my-9.5}" width="${w}" height="19" rx="9.5" fill="#FCFAF3" stroke="#E6E0C8"/>`+
    `<text x="${mx}" y="${my+3.5}" text-anchor="middle" fill="#55655A">${label}</text></g>`;
}

/* Nette plantposities in verband (halfsteens) binnen een rechthoek.
   Strak-gegarandeerd (fixrelease 14-07): één vaste rastermaat, elke rij
   perfect gecentreerd, klassiek om-en-om patroon (k en k−1). Rijen met
   een oneven aantalsverschil verspringen daardoor vanzelf een halve
   kolom; reeksen buurrijen met gelijke pariteit krijgen om-en-om ±¼
   kolom zodat er nooit doorlopende kolommen ontstaan. Exact n punten,
   geen globale hercentrering meer (die trok het patroon scheef). */
function verbandPos(n,w,h){
  n = Math.max(1, Math.round(n));
  if (n === 1) return { pos: [[w/2, h/2]], pitch: Math.min(w,h) };
  const R0 = Math.max(1, Math.round(Math.sqrt(n * (h/Math.max(w,1)) * 2/Math.sqrt(3))));
  let beste = null;
  for (let R = Math.max(1,R0-1); R <= Math.min(n, R0+1); R++){
    const nB = Math.floor(R/2), nA = R - nB;
    const kA = Math.max(R>1?2:1, Math.ceil((n + nB) / R));
    const over = nA*kA + nB*(kA-1) - n;
    const straf = over + (over > nA ? 100 : 0) + Math.abs(R-R0)*0.5;
    if (!beste || straf < beste.straf) beste = { R, kA, over, straf };
  }
  const R = beste.R, kA = beste.kA;
  const kRij = [];
  for (let r=0;r<R;r++) kRij.push(r%2===0 ? kA : kA-1);
  let over = beste.over;
  const aVolg = [];
  for (let i=0;i<R;i++){ const r = (i%2===0) ? Math.floor(i/2) : R-1-Math.floor(i/2); if (r%2===0 && aVolg.indexOf(r)<0) aVolg.push(r); }
  for (let ai=0; ai<aVolg.length && over>0; ai++){ kRij[aVolg[ai]]--; over--; }
  for (let r=0; r<R && over>0; r++){ if (kRij[r]>1){ kRij[r]--; over--; } }
  const kMax = Math.max.apply(null, kRij);
  const px = w/Math.max(kMax,1), py = h/R;
  const start = kRij.map(k => (w-(k-1)*px)/2);
  const schuif = new Array(R).fill(0);
  let runStart = 0;
  for (let r=1;r<=R;r++){
    let breek = (r===R);
    if (!breek){
      const d = Math.abs((((start[r]-start[r-1]) % px)+px)%px);
      breek = !(d < px*0.25 || d > px*0.75);
    }
    if (breek){
      const len = r - runStart;
      if (len > 1) for (let i=0;i<len;i++) schuif[runStart+i] = (i%2 ? 1 : -1)*px/4;
      runStart = r;
    }
  }
  const pos = [];
  for (let r=0;r<R;r++){
    let x0 = start[r] + schuif[r];
    if (x0 < -1e-6) x0 += px/2;
    if (x0 + (kRij[r]-1)*px > w+1e-6) x0 -= px/2;
    const y = py*(r+0.5);
    for (let c=0;c<kRij[r];c++) pos.push([x0+c*px, y]);
  }
  return { pos, pitch:Math.min(px,py) };
}

/* Nette posities binnen een cirkel: concentrische ringen met een
   gelijkmatige rand (fixrelease 14-07 — verving het hoekige rooster
   waarvan de buitenrand rafelig oogde). Puntental per ring evenredig
   met de omtrek (grootste-rest), ringen verspringen om-en-om, exact n. */
function rondVerband(n,R){
  n = Math.max(1, Math.round(n));
  if (n === 1) return { pos: [[0,0]], s: R };
  if (n <= 4){
    const pos = [], r0 = R*0.5;
    for (let i=0;i<n;i++){ const t = -Math.PI/2 + i*2*Math.PI/n; pos.push([r0*Math.cos(t), r0*Math.sin(t)]); }
    return { pos, s: R };
  }
  const J = Math.max(1, Math.round(Math.sqrt(n/Math.PI)));
  const centrum = J >= 2;
  const rest = n - (centrum ? 1 : 0);
  const rMax = R*0.86;
  const radii = [];
  for (let j=1;j<=J;j++) radii.push(rMax*j/J);
  const som = radii.reduce(function(a,b){return a+b;},0);
  const kwot = radii.map(function(r){return rest*r/som;});
  const k = kwot.map(Math.floor);
  let tekort = rest - k.reduce(function(a,b){return a+b;},0);
  const restvolg = kwot.map(function(q,i){return [q-Math.floor(q),i];}).sort(function(a,b){return b[0]-a[0];});
  for (let i=0;i<tekort;i++) k[restvolg[i%restvolg.length][1]]++;
  for (let j=0;j<J;j++) if (k[j] > 0 && k[j] < 3){
    const t = k[j]; k[j] = 0;
    k[Math.min(J-1,j+1)] += t;
  }
  const pos = centrum ? [[0,0]] : [];
  for (let j=0;j<J;j++){
    const kk = k[j]; if (!kk) continue;
    const rot = (j%2)*Math.PI/kk - Math.PI/2;
    for (let i=0;i<kk;i++){
      const t = rot + i*2*Math.PI/kk;
      pos.push([radii[j]*Math.cos(t), radii[j]*Math.sin(t)]);
    }
  }
  return { pos, s: rMax/J };
}

function schaalTeken(aantal,cap){
  if (aantal<=cap) return { teken:aantal, k:1 };
  const k = Math.ceil(aantal/cap);
  return { teken:Math.ceil(aantal/k), k };
}
function zetNoot(k,verband){
  el('vizNoot').textContent = 'Bovenaanzicht · na uitgroei · ' + (verband ? 'geplant in verband · ' : '') +
    (k>1 ? `vereenvoudigd, 1 bolletje ≈ ${k} planten` : 'elk bolletje is 1 plant');
}

/* ── Tekeningen (bovenaanzicht) ── */
const svgKop = h => `<svg viewBox="0 0 720 ${h}" role="img" aria-label="Schets van de beplanting">`;

function tekenLijn(r){
  const { teken,k } = schaalTeken(r.aantal, 140);
  const x0=68, W=584;
  const dubbel = s.dubbel && teken>3;
  const gap = teken>1 ? W/(teken-1) : 0;
  const verh = klem(r.blad/r.effA, 0.25, 2.5);
  const rr  = dubbel ? klem(gap*0.95*verh,8,26) : (teken>1 ? klem(gap*0.52*verh,6,40) : klem(32*verh,10,60));
  const off = dubbel ? klem(rr*1.05,16,30) : 0;
  const H   = off + Math.max(rr*0.8, 10);
  const bracket = !dubbel && teken>1 && gap>=52;
  const midY = H + (bracket ? 58 : 26);
  let inner = `<rect x="${(x0-rr*0.8).toFixed(1)}" y="${midY-H}" width="${(W+rr*1.6).toFixed(1)}" height="${H*2}" rx="${Math.min(28,H)}" fill="#EDE6D2" stroke="#E0D7BD"/>`;
  if (bracket){
    const bx=x0+gap/2, by=midY-H-14;
    inner += `<path d="M${x0} ${by+8}v-8h${gap}v8" fill="none" stroke="#A9B49F" stroke-width="1.2"/>`+
      `<text x="${bx}" y="${by-7}" text-anchor="middle" font-family="'Hanken Grotesk',system-ui" font-size="11" font-weight="600" fill="#7C8A7B">± ${fmtAfstand(r.effA)}</text>`;
  }
  for (let i=0;i<teken;i++)
    inner += blad(x0+(teken>1?i*gap:W/2), midY+(dubbel?(i%2?off:-off):0), rr, i);
  inner += maatlijn(x0-rr*0.8, midY+H+34, x0+W+rr*0.8, midY+H+34, fmtMaat(s.lijnLen));
  zetNoot(k, dubbel);
  return svgKop(midY+H+62)+inner+'</svg>';
}

function tekenVak(r){
  const { teken,k } = schaalTeken(r.aantal, 380);
  let inner='', hoogte;
  if (s.mode==='rond'){
    const R = 150, cx=360, cy=R+20;
    const Rcm = Math.max(inMeter(s.diam)*50, 1);
    const exactPot = (k===1 && r.bak && r.rondPts);
    const bolD = (r.bak && r.potBol) ? r.potBol : r.blad;
    const maxAfst = exactPot ? r.rondPts.reduce((mx,p)=>Math.max(mx, Math.hypot(p[0],p[1])), 0) : 0;
    const f = exactPot ? (R-2)/Math.max(Rcm, maxAfst + bolD/2, 0.5*bolD) : null;
    const Rpx = exactPot ? Rcm*f : R-2;
    inner += `<circle cx="${cx}" cy="${cy}" r="${Rpx.toFixed(1)}" fill="#EDE6D2" stroke="#E0D7BD"/>`;
    if (exactPot){
      const rr = Math.max(bolD*f*0.5, 4.5);
      r.rondPts.forEach((p,i)=> inner += blad(cx+p[0]*f, cy+p[1]*f, rr, i));
      zetNoot(k, false);
    } else {
      const fs = (R-6)/Math.max(Rcm, 1);
      const rv = rondVerband(teken, Rpx-10);
      const rr = klem(Math.max(r.blad*fs*0.5, rv.s*.32), 4.5, 26);
      rv.pos.forEach((p,i)=> inner += blad(cx+p[0], cy+p[1], rr, i));
      zetNoot(k, true);
    }
    inner += maatlijn(cx-Rpx, cy+R+36, cx+Rpx, cy+R+36, `⌀ ${fmtMaat(s.diam)}`);
    hoogte = cy+R+66;
  } else {
    const L = s.rechtL, B = s.rechtB;
    const maxW=560, maxH=252, sch=Math.min(maxW/L, maxH/B);
    const w=Math.max(L*sch,120), h=Math.max(B*sch,64), x=360-w/2, y=26;
    inner += `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="18" fill="#EDE6D2" stroke="#E0D7BD"/>`;
    const Lcm = inMeter(L)*100, Bcm = inMeter(B)*100;
    const schMin = Math.min(w/Math.max(Lcm,1), h/Math.max(Bcm,1));
    if (r.bak && k===1 && r.vx){
      /* bak: exact de getelde posities, tegen de rand */
      const schX = w/Lcm, schY = h/Bcm;
      const rr = klem(r.blad*schMin*0.5, 4.5, Math.min(w,h));
      let ix = 0;
      for (let ry=0; ry<r.vy.n; ry++)
        for (let cx2=0; cx2<r.vx.n; cx2++)
          inner += blad(x + (r.vx.marge + cx2*r.vx.stap)*schX,
                        y + (r.vy.marge + ry*r.vy.stap)*schY, rr, ix++);
      zetNoot(k, false);
    } else {
      const pad = 12;
      const vb = verbandPos(teken, w-pad*2, h-pad*2);
      const rr = klem(Math.max(r.blad*schMin*0.5, vb.pitch*.3), 4.5, 30);
      vb.pos.forEach((p,i)=> inner += blad(x+pad+p[0], y+pad+p[1], rr, i));
      zetNoot(k, r.verband);
    }
    const dimY = y+h+34;
    inner += maatlijn(x, dimY, x+w, dimY, fmtMaat(L));
    inner += maatlijn(x+w+40, y, x+w+40, y+h, fmtMaat(B), true);
    hoogte = dimY+30;
  }
  return svgKop(hoogte)+inner+'</svg>';
}

/* ── Tekst & pillen ── */
const IC_AFSTAND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 12h16M4 12l3-3M4 12l3 3M20 12l-3-3M20 12l-3 3"/></svg>';
const IC_DICHT   = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="7" cy="12" r="2.2"/><circle cx="17" cy="12" r="2.2"/><circle cx="12" cy="6.5" r="2.2"/><circle cx="12" cy="17.5" r="2.2"/></svg>';
const IC_BLAD    = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 19C5 10 11 5 20 4c-.5 9-5 15-15 15Z"/><path d="M7 17C10 13 13 10 17 7"/></svg>';

function stelPlekVoor(){
  if (s.plekHandmatig || s.mode === 'lijn') return;
  if (s.mode === 'rond'){
    const d = inMeter(s.diam)*100;
    if (d <= 60) s.plek = 'bak';
    else if (d >= 100) s.plek = 'vollegrond';
  } else {
    const L = inMeter(s.rechtL)*100, B = inMeter(s.rechtB)*100;
    const mn = Math.min(L,B), mx = Math.max(L,B);
    if (mn <= 45 && mx <= 130) s.plek = 'bak';
    else if (mx >= 180 || mn >= 80) s.plek = 'vollegrond';
  }
}
function vernieuwPlek(){
  el('plekVeld').hidden = (s.mode === 'lijn');
  alle('[data-plek]').forEach(x => x.setAttribute('aria-pressed', x.dataset.plek === s.plek));
}

function vernieuwUitkomst(){
  if (ongeldigeVelden.size){
    /* geen nieuw advies zolang de invoer ongeldig is */
    root.classList.add('pw-wacht');
    el('srUitkomst').textContent = 'De invoer is nog niet geldig; het advies is niet bijgewerkt.';
    return;
  }
  root.classList.remove('pw-wacht');
  const uit = root.querySelector('.uitkomst');
  if (uit) uit.removeAttribute('aria-busy');
  stelPlekVoor(); vernieuwPlek();
  const r = bereken();
  toonAantal(r.aantal);
  el('plakNum') && (el('plakNum').textContent = nf.format(r.aantal));
  const mv = r.aantal === 1 ? 'plant' : 'planten';
  el('numEenheid') && (el('numEenheid').textContent = mv);
  el('plakEenheid') && (el('plakEenheid').textContent = mv);

  let zin='', pil2='';
  const oppZin = r.opp!==null && r.opp>=1 ? ` — zo’n ${nf1.format(Math.round(r.opp*10)/10)} m²` : '';
  if (s.mode==='lijn'){
    zin = `Voor een haag of rij van <b>${fmtMaat(s.lijnLen)}</b>${s.dubbel?' · dubbele rij':''}.`;
    const pmv = r.perM*(s.dubbel?2:1);
    pil2 = pmv >= 1
      ? `≈ ${nf1.format(Math.round(pmv*10)/10)} per meter`
      : `≈ 1 per ${nf1.format(Math.round(10/pmv)/10)} m`;
  } else if (s.mode==='rechthoek'){
    zin = `Voor een ${r.bak?'bak':'border'} van <b>${fmtMaat(s.rechtL)} × ${fmtMaat(s.rechtB)}</b>${oppZin}.`;
    pil2 = r.bak
      ? `${r.cY} ${r.cY===1?'rij':'rijen'} × ${r.cX} planten`
      : `≈ ${nf1.format(Math.round(dichtheidPerM2()*10)/10)} per m² · in verband`;
  } else {
    zin = `Voor een ${r.bak?'pot':'ronde border'} van <b>⌀ ${fmtMaat(s.diam)}</b>${oppZin}.`;
    pil2 = r.bak
      ? `≈ ${Math.max(1,Math.round(r.aantal/Math.max(r.opp,0.01)))} per m² · in ringen`
      : `≈ ${nf1.format(Math.round(dichtheidPerM2()*10)/10)} per m² · in verband`;
  }
  el('zin').innerHTML = zin;
  el('srUitkomst').textContent = `Advies: ${nf.format(r.aantal)} ${mv}. ${el('zin').textContent}`;
  const bron = s.dichtheid ? `kwekersadvies ${nf1.format(s.dichtheid)} per m²` : `plantafstand ${fmtAfstand(r.effA)}`;
  el('pillen').innerHTML =
    `<span class="pil">${IC_AFSTAND}${bron}</span>`+
    `<span class="pil">${IC_DICHT}${pil2}</span>`+
    (r.bak
      ? `<span class="pil">${IC_BLAD}tegen de rand geplant</span>`
      : (Math.abs(r.blad - r.effA) >= 1 ? `<span class="pil">${IC_BLAD}plant ⌀ ±${fmtAfstand(r.blad)}</span>` : ''));

  el('tip').innerHTML = r.bak
    ? `${IC_BLAD}<span>In een pot of bak geldt dezelfde plantafstand als in de border, maar de buitenste planten zetten we <b>tégen de rand</b> — zo valt het blad er mooi overheen.</span>`
    : `${IC_BLAD}<span>Het advies is geplant <b>in verband</b> (verspringende rijen) op de aanbevolen afstand — zo groeit het vak gelijkmatig dicht.</span>`;

  el('viz').innerHTML = s.mode==='lijn' ? tekenLijn(r) : tekenVak(r);
}

/* ── Zichtbaarheid velden / tabs ── */
function vernieuwVelden(){
  alle('[data-mode]').forEach(n => n.hidden = n.dataset.mode!==s.mode);
  el('rijDubbel').closest('.veld').hidden = (s.mode!=='lijn') || !haagPlausibel;
}
alle('[data-tab]').forEach(b => b.addEventListener('click', () => {
  s.mode = b.dataset.tab;
  s.plekHandmatig = false;
  alle('[data-tab]').forEach(x => x.setAttribute('aria-pressed', x===b));
  vernieuwVelden(); vernieuwUitkomst();
}));

alle('[data-plek]').forEach(b => b.addEventListener('click', () => {
  s.plek = b.dataset.plek;
  s.plekHandmatig = true;
  vernieuwUitkomst();
}));

/* ── Invulvelden — zichtbare, gekoppelde foutafhandeling ──
   Regels: fout is zichtbaar als tekst bij het veld (aria-describedby,
   role=alert), er wordt níet stil geklemd en zolang een veld ongeldig
   is wordt geen nieuw advies berekend. */
const eenheidVan = key => key==='afstand' ? 'cm' : s.eenheid;
const confVan    = key => CONF[key][eenheidVan(key)];
const GETAL_RE = /^\s*\d+(?:[.,]\d+)?\s*$/;

function schrijfVeld(id,key){
  el(id).value = fmtGetal(s[key], eenheidVan(key));
}
function stelInvoerIn(id,key,behoudFysiek){
  const c = confVan(key);
  if (behoudFysiek){
    const v = s.eenheid==='m' ? s[key]/100 : s[key]*100;
    s[key] = klem(v, c.min, c.max);
  } else s[key] = c.std;
  schrijfVeld(id,key);
}
function foutEl(id){ return document.getElementById('pw-fout-'+id); }
function zetFout(id, inp, melding){
  const f = foutEl(id);
  if (melding){
    ongeldigeVelden.add(id);
    inp.closest('.invoer').classList.add('ongeldig');
    inp.setAttribute('aria-invalid','true');
    if (f){ f.textContent = melding; f.hidden = false; }
  } else {
    ongeldigeVelden.delete(id);
    inp.closest('.invoer').classList.remove('ongeldig');
    inp.removeAttribute('aria-invalid');
    if (f){ f.textContent = ''; f.hidden = true; }
  }
}
function koppelVeld(id,key){
  const inp = el(id);
  const controleer = () => {
    const c = confVan(key);
    const eenh = eenheidVan(key);
    if (!GETAL_RE.test(inp.value)){
      zetFout(id, inp, `Vul een getal in (tussen ${fmtGetal(c.min,eenh)} en ${fmtGetal(c.max,eenh)} ${eenh}).`);
      vernieuwUitkomst(); return;
    }
    const v = parseGetal(inp.value);
    if (v === null || v <= 0){
      zetFout(id, inp, `Vul een getal groter dan nul in.`);
      vernieuwUitkomst(); return;
    }
    if (v < c.min || v > c.max){
      zetFout(id, inp, v < c.min
        ? `Minimaal ${fmtGetal(c.min,eenh)} ${eenh}.`
        : `Maximaal ${fmtGetal(c.max,eenh)} ${eenh}.`);
      vernieuwUitkomst(); return;   /* niet stil klemmen, niet rekenen */
    }
    zetFout(id, inp, null);
    s[key] = v;
    if (key==='afstand'){ s.dichtheid = null; zetChipActief(); vernieuwAanbevolen(); }
    vernieuwUitkomst();
  };
  inp.addEventListener('input', controleer);
  inp.addEventListener('blur', () => {
    if (ongeldigeVelden.has(id)) return;    /* fout blijft zichtbaar staan */
    schrijfVeld(id,key);
  });
  inp.addEventListener('focus', () => inp.select());
  inp.addEventListener('keydown', e => { if (e.key==='Enter') inp.blur(); });
}
INVOEREN.forEach(([id,key]) => koppelVeld(id,key));
koppelVeld('sAfstand','afstand');

alle('.invoer').forEach(box => box.addEventListener('mousedown', e => {
  const i = box.querySelector('input');
  if (e.target!==i){ e.preventDefault(); i.focus(); i.select(); }
}));

/* Plantafstand-chips — altijd precies één keuze actief */
function zetChipActief(){
  alle('[data-afstand]').forEach(x => {
    x.setAttribute('aria-pressed', String(+x.dataset.afstand === s.afstand && !s.dichtheid));
  });
}
alle('[data-afstand]').forEach(b => b.addEventListener('click', () => {
  s.afstand = +b.dataset.afstand;
  s.dichtheid = null;
  if (!productPlant) s.bladMaat = s.afstand;
  zetFout('sAfstand', el('sAfstand'), null);
  schrijfVeld('sAfstand','afstand');
  zetChipActief(); vernieuwAanbevolen(); vernieuwUitkomst();
}));

alle('[data-stap]').forEach(b => b.addEventListener('click', () => {
  const deel = b.dataset.stap.split(':');
  const key = deel[0], richting = +deel[1];
  const id = key==='afstand' ? 'sAfstand' : INVOEREN.find(x=>x[1]===key)[0];
  const c = confVan(key);
  const genest = Math.round(s[key]/c.step)*c.step;
  s[key] = klem(genest + c.step*richting, c.min, c.max);
  zetFout(id, el(id), null);
  schrijfVeld(id,key);
  if (key==='afstand'){ s.dichtheid = null; zetChipActief(); vernieuwAanbevolen(); }
  vernieuwUitkomst();
}));

alle('[data-eenheid]').forEach(b => b.addEventListener('click', () => {
  if (b.dataset.eenheid===s.eenheid) return;
  alle('[data-eenheid]').forEach(x => x.setAttribute('aria-pressed', x===b));
  s.eenheid = b.dataset.eenheid;
  INVOEREN.forEach(([id,key]) => { zetFout(id, el(id), null); stelInvoerIn(id,key,true); });
  alle('[data-eenh]').forEach(x => x.textContent = s.eenheid);
  vernieuwUitkomst();
}));

el('knopDubbel').addEventListener('click', () => {
  s.dubbel = !s.dubbel;
  el('knopDubbel').setAttribute('aria-checked', s.dubbel);
  vernieuwUitkomst();
});
el('rijDubbel').addEventListener('click', e => { if (e.target.closest('.tekst')) el('knopDubbel').click(); });

/* ── Aanbevolen-banner: toont de actieve bron en of er is aangepast ── */
function vernieuwAanbevolen(){
  const bak = el('aanbevolen');
  if (!bak || aanbevolenAfstand === null) return;
  const aangepast = !s.dichtheid && Math.abs(s.afstand - aanbevolenAfstand.cm) >= 0.5;
  bak.classList.toggle('aangepast', aangepast);
  if (s.dichtheid){
    bak.querySelector('#pw-aanbevolenTekst').innerHTML =
      `Kwekersadvies voor deze uitvoering: <b>${nf1.format(s.dichtheid)} planten per m²</b> (± ${fmtAfstand(100/Math.sqrt(s.dichtheid))} uit elkaar).`;
  } else if (aangepast){
    bak.querySelector('#pw-aanbevolenTekst').innerHTML =
      `Je rekent nu met een eigen afstand van <b>${fmtAfstand(s.afstand)}</b> (aanbevolen: ${fmtAfstand(aanbevolenAfstand.cm)}).`;
  } else {
    const cm = aanbevolenAfstand.cm, pm = 100/cm;
    bak.querySelector('#pw-aanbevolenTekst').innerHTML = pm >= 1
      ? `Aanbevolen plantafstand voor deze plant: <b>${fmtAfstand(cm)}</b> — zo’n <b>${nf1.format(pm)} per meter</b>.`
      : `Aanbevolen plantafstand voor deze plant: <b>${fmtAfstand(cm)}</b> — <b>1 per ${nf2.format(cm/100)} meter</b>.`;
  }
}

/* ── Productmodus ── */
function startProductmodus(cm){
  productPlant = true;
  aanbevolenAfstand = { cm };
  s.afstand = cm;
  s.bladMaat = cm;
  el('lblAfstand').textContent = 'Ruimte per plant';
  el('aanbevolen').hidden = false;
  el('afstandVrij').hidden = true;
  vernieuwAanbevolen();
  el('knopAanpas').addEventListener('click', () => {
    const open = el('afstandVrij').hidden;
    el('afstandVrij').hidden = !open;
    el('knopAanpas').setAttribute('aria-expanded', open);
    el('knopAanpas').textContent = open ? 'Verberg' : 'Aanpassen';
    if (open && !root.querySelector('.pw-herstel')){
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'chip pw-herstel'; chip.dataset.afstand = cm;
      chip.innerHTML = `Aanbevolen · <b>${fmtAfstand(cm)}</b>`;
      chip.addEventListener('click', () => {
        s.afstand = cm;
        s.dichtheid = huidigeDichtheid();
        zetFout('sAfstand', el('sAfstand'), null);
        schrijfVeld('sAfstand','afstand');
        zetChipActief(); vernieuwAanbevolen(); vernieuwUitkomst();
      });
      el('afstandVrij').querySelector('.chips').prepend(chip);
      zetChipActief();
    }
  });
}

/* ── Variant volgen: zichtbaarheid en advies wisselen mee ── */
function huidigeDichtheid(){
  return beoordeelVariant(huidigeVariantTitel).dichtheid;
}
function pasVariantToe(){
  const b = beoordeelVariant(huidigeVariantTitel);
  const verberg = productVerbergen || b.verberg;
  root.style.display = verberg ? 'none' : '';
  if (plak){
    if (verberg){ plak.classList.remove('zichtbaar'); plak.setAttribute('aria-hidden','true'); plak.tabIndex = -1; }
  }
  if (verberg) return;
  s.dichtheid = b.dichtheid;
  if (b.dichtheid){
    const cmEq = 100/Math.sqrt(b.dichtheid);
    s.afstand = Math.round(cmEq*10)/10;
    s.bladMaat = s.afstand;
  } else if (aanbevolenAfstand){
    s.afstand = aanbevolenAfstand.cm;
    s.bladMaat = aanbevolenAfstand.cm;
  }
  zetFout('sAfstand', el('sAfstand'), null);
  schrijfVeld('sAfstand','afstand');
  zetChipActief(); vernieuwAanbevolen(); vernieuwUitkomst();
}
function volgVariantkiezer(){
  const picker = document.querySelector('[data-variant-picker]');
  if (!picker) return;
  picker.addEventListener('change', () => {
    const t = pickerVariantTitel();
    if (t && t !== huidigeVariantTitel){
      huidigeVariantTitel = t;
      pasVariantToe();
    }
  });
  const t0 = pickerVariantTitel();
  if (t0) huidigeVariantTitel = t0;
}

/* ── Sticky resultaat op mobiel — boven de koopbalk, nooit eroverheen ── */
const plak = el('plak'), paneel = root.querySelector('.uitkomst');
let plakActief = false;
function positioneerPlak(){
  if (!plak || !plak.parentNode) return;
  const bar = document.querySelector('.product-mobile-buybar');
  let onder = 14;
  if (bar){
    const st = getComputedStyle(bar);
    const zichtbaarBar = st.display !== 'none' && st.visibility !== 'hidden' && bar.offsetHeight > 0;
    if (zichtbaarBar && (st.position === 'fixed' || st.position === 'sticky')){
      onder = bar.offsetHeight + 10;
    }
  }
  plak.style.bottom = onder + 'px';
}
if (root.dataset.sticky === 'false'){
  if (plak) plak.remove();
} else if (plak){
  document.body.appendChild(plak);
  plak.setAttribute('aria-hidden', 'true');
  plak.tabIndex = -1;
  plakActief = true;
  positioneerPlak();
  new IntersectionObserver(entries => {
    const toon = !entries[0].isIntersecting && root.style.display !== 'none';
    plak.classList.toggle('zichtbaar', toon);
    plak.setAttribute('aria-hidden', String(!toon));
    plak.tabIndex = toon ? 0 : -1;
    if (toon) positioneerPlak();
  }, { threshold:.25 }).observe(paneel);
  plak.addEventListener('click', () => paneel.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block:'center' }));
  window.addEventListener('resize', positioneerPlak);
}
/* thema-editor: sectie wordt herladen → sticky netjes opruimen */
document.addEventListener('shopify:section:unload', function(e){
  if (e.target && e.target.querySelector && (e.target.querySelector('#plantwijzer') || e.target.contains(root))){
    if (plak && plak.parentNode) plak.remove();
  }
});

/* ── Start ── */
INVOEREN.forEach(([id,key]) => stelInvoerIn(id,key,false));
const pootCm = leesPootafstand();
const productVerbergen = productAltijdVerbergen();
if (pootCm === null || productVerbergen){
  if (plak && plak.parentNode) plak.remove();
  root.style.display = 'none';
  if (pootCm === null) return;
}
startProductmodus(pootCm);
/* standaardvorm: rij alleen voor haagbare planten, anders vak */
if (!haagPlausibel){
  s.mode = 'rechthoek';
  alle('[data-tab]').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.tab === 'rechthoek')));
}
schrijfVeld('sAfstand','afstand');
zetChipActief();
vernieuwVelden();
volgVariantkiezer();
pasVariantToe();
})();
